type AmplifyBroadcastChannelData = { isLoggedIn: boolean };
type AmplifyBroadcastChannelPost = { isLoggedIn: boolean };

export const useAmplifyAuthBroadcastChannel = () => {
  const { data: amplifyAuthState, post: broadcastAmplifyAuthStateChange } =
    useBroadcastChannel<
      AmplifyBroadcastChannelData,
      AmplifyBroadcastChannelPost
    >({
      name: "amplify-auth-state",
    });

  return {
    amplifyAuthState,
    broadcastAmplifyAuthStateChange,
  };
};
